<div class="wrapper cv-dialog-form">
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Origin'"
				[placeholder]="'Please Select'"
				[options]="originOptions"
				[selectedValue]="selectedOrigin"
				[clearSelection]="false"
				(valuesChange)="onOriginChange($event)">
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-multiselect *ngIf="assetsLoaded"
											#assetsSelector
											[label]="'Assets'"
											[placeholder]="'Please Select'"
											[values]="selectedAssets"
											[optionText]="'text'"
											[optionValue]="'id'"
											[options]="getAssetOptions()"
											[required]="true"
											(valuesChange)="onAssetsChange($event)">
			</cv-multiselect>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-input (controlKeyup)="config.description = $event.value;"
								[value]="config.description"
								[label]="'Description'"
								[type]="'textarea'"
								[minlength]="1"
								[required]="true">
			</cv-input>
		</div>
	</div>
</div>
